import React, { useState, useRef } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Modal,
  Button,
  TextField,
  Paper,
  LinearProgress,
  FormControl,
  MenuItem,
  Select,
  Grid,
} from "@mui/material";
import { MoreVert, Close } from "@mui/icons-material";
import { styled } from "@mui/system";
import { InputLabel } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CloseIcon from "@mui/icons-material/Close";


import { ScriptHtml } from "../../utils";

const ListingCustomCard = ({ title, summary, price, image, onBack,openProductModal,data }) => {
  const [openModal, setOpenModal] = useState(false);
  console.log("image",image)
  console.log("data",data)
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(false);
  const [editedTitle, setEditedTitle] = useState(title);
  const [editedSummary, setEditedSummary] = useState(summary);
  const imageInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleMenuClicked = (item) => {
    setOpenModal(true)
    setSelectedItem(item)
  };
  const handleCloseModal = () => setOpenModal(false);

  const handleOpenEditModal = () => {
    setOpenModal(false);
    // setOpenEditModal(true);
    console.log("selectedItem",selectedItem)
    openProductModal(selectedItem)
  };
  const handleCloseEditModal = () => setOpenEditModal(false);
  const StyledPaper = styled(Paper)({
    padding: "16px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: "#fff",
  });
  const handleFileChange = (event) => {
    const files = event.target.files;
    const validFiles = [];
    const errors = [];

    if (files) {
      if (selectedFiles.length + files.length > 4) {
        setErrorMessage("You can only upload up to 4 images.");
        return;
      }

      Array.from(files).forEach((file) => {
        if (file.type === "image/jpeg" || file.type === "image/png") {
          validFiles.push(file);
        } else {
          errors.push(
            `${file.name} is not a valid image. Only .jpg and .png are allowed.`
          );
        }
      });

      if (errors.length > 0) {
        setErrorMessage(errors.join(", "));
      } else {
        setErrorMessage(null);
      }

      setSelectedFiles((prev) => [...prev, ...validFiles]);
    }
  };

  const [formValues, setFormValues] = useState({
    productid: "",
    productname: "",
    description: "",
    price: "",
    discount: "",
    cutoffprice: "",
    category1: "",
    category2: "",
    category3: "",
    category4: "",
    category5: "",
    category6: "",
    sku: "",
    imageid: "",
    imagedescription: "",
    weight: "",
    frames: "",
    holescount: "",
    tags: "",
    regularprice: "",
    saleprice: "",
    published: "",
    featured: "",
    instock: "",
    backorders: "",
    stock: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const ImageItem = ({ name, error, onRemove }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        p: 1,
        border: "1px solid #ddd",
        borderRadius: "4px",
      }}
    >
      <img
        src={name}
        alt="Product thumbnail"
        style={{
          width: "50px",
          height: "50px",
          marginRight: "8px",
          objectFit: "cover",
        }}
      />
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="body2" color="textSecondary">
          {name}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={100}
          sx={{
            height: "6px",
            borderRadius: "2px",
            mt: 1,
            backgroundColor: "inherit",
            "& .MuiLinearProgress-bar": {
              backgroundColor: error ? "red" : "green",
            },
          }}
        />
      </Box>

      <IconButton onClick={onRemove} sx={{ ml: 1 }}>
        <CloseIcon />
      </IconButton>
    </Box>
  );

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"], // Remove formatting button
    ],
  };
  const handleClickrest = () => {
    alert("Reset Succesfull!");
  };
  const handleClicklist = () => {
    alert("Added Succesfully!");
  };

  return (
    <>
      {/* Main Card */}

      {/* {data && data.map((item)=>{ */}
  {/* return (   */}
     <Card
      sx={{
        width: 320,
        height: 240,
        margin: 2,
        borderRadius: 2,
        boxShadow: 3,
        overflow: "hidden",
      }}
    >



<CardContent sx={{ padding: 1, height: "100%" }}>
 
 <Box
   sx={{
     display: "flex",
     justifyContent: "space-between",
     alignItems: "flex-start",
     marginBottom: 2,
   }}
 >
 

   <CardMedia
     component="img"
     sx={{ width: 80, height: 80, borderRadius: 1 }}
     image={data['images'][0]['image_url']}
     alt={data.name}
   />
 
   <Box sx={{ flex: 1, marginLeft: 2 }}>
     <Typography
       sx={{ fontSize: 16, fontWeight: "bold", marginBottom: 1 }}
     >
       {data.name}
     </Typography>
   </Box>
   <IconButton onClick={()=>handleMenuClicked(data)}>
     <MoreVert />
   </IconButton>
 </Box>

 
 <Typography
   sx={{ fontSize: 20, fontWeight: "bold", marginBottom: 1 }}
 >
   {data.price}
 </Typography>

 
 <Typography variant="body2" color="text.secondary">
   {ScriptHtml(data.description)}
 </Typography>
</CardContent>
   
    </Card>
    {/* ) */}
  {/* })} */}


   

      
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 2,
            boxShadow: 24,
          }}
        >
          <Typography variant="h6" sx={{ marginBottom: 2 }}>
            Edit/Delete Options
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button variant="contained" onClick={handleOpenEditModal}>
              Edit
            </Button>
            <Button variant="contained" color="warning">
              Cancel
            </Button>
            <Button variant="contained" color="error">
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Edit Modal */}
      <Modal open={false} onClose={handleCloseEditModal}>
        <Box sx={{ mt: 3, borderRadius: "12px" }}>
          <Box
            sx={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              maxHeight: "80vh",
              bgcolor: "background.paper",
              p: 4,
              borderRadius: 2,
              boxShadow: 24,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              overflowY: "auto",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <IconButton
              onClick={handleCloseEditModal}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <Close />
            </IconButton>
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Edit Listing
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <StyledPaper sx={{ flex: 1 }}>
                <Box sx={{}}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography variant="h6" gutterBottom>
                      Select category
                    </Typography>
                    <FormControl fullWidth sx={{ mb: 2 }} size="small">
                      <InputLabel>Select category</InputLabel>
                      <Select
                        name="category"
                        value={formValues.category}
                        onChange={handleInputChange}
                        label="Select category"
                      >
                        <MenuItem value="Seller1">Seller 1</MenuItem>
                        <MenuItem value="Seller2">Seller 2</MenuItem>
                        <MenuItem value="Seller3">Seller 3</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" gutterBottom>
                      Listing Name
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      name="productname"
                      value={formValues.productname}
                      onChange={handleInputChange}
                      sx={{ mb: 2 }}
                    />
                  </Box>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="h6" gutterBottom>
                        Listing Description33
                      </Typography>
                      <ReactQuill
                        theme="snow"
                        value={formValues.category6}
                        onChange={(value) =>
                          setFormValues({ ...formValues, category6: value })
                        }
                        modules={modules}
                        style={{ height: "200px" }}
                      />
                    </Box>
                  </Grid>
                </Box>
                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 7 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={handleClickrest}
                    style={{ padding: "10px 20px" }}
                  >
                    Reset
                  </Button>

                  <Button
                    variant="contained"
                    color="success"
                    size="large"
                    onClick={handleClicklist}
                    style={{ padding: "10px 20px" }}
                  >
                    Add Listing
                  </Button>
                </Box>
              </StyledPaper>

              <Box sx={{ width: "35%" }}>
                <StyledPaper sx={{ mb: 2, textAlign: "center" }}>
                  {selectedFiles.length > 0 ? (
                    <img
                      src={URL.createObjectURL(selectedFiles[0])}
                      alt="Product"
                      style={{ width: "80%" }}
                    />
                  ) : (
                    <img
                      src="/placeholder.jpg"
                      alt="Placeholder"
                      style={{ width: "80%" }}
                    />
                  )}
                </StyledPaper>

                <StyledPaper>
                  <Typography variant="h6" gutterBottom>
                    Listing Gallery
                  </Typography>
                  <Box
                    sx={{
                      border: "2px dashed #ddd",
                      borderRadius: "4px",
                      p: 2,
                      textAlign: "center",
                      mb: 2,
                      cursor: "pointer",
                    }}
                    onClick={() => imageInputRef.current?.click()}
                  >
                    <img
                      src="/ph_image-light.svg"
                      alt="Product"
                      style={{ width: "20%" }}
                    />
                    <Typography variant="body1" color="textSecondary">
                      Drop your image here, or browse
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      500 x 500 pixcel less than 50kb
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Jpeg, png are allowed
                    </Typography>
                    <input
                      type="file"
                      accept="image/jpeg, image/png"
                      multiple
                      ref={imageInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </Box>

                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    {selectedFiles.map((file, index) => (
                      <ImageItem
                        key={index}
                        name={URL.createObjectURL(file)}
                        error={
                          file.type !== "image/jpeg" &&
                          file.type !== "image/png"
                        }
                        onRemove={() => {
                          setSelectedFiles((prevFiles) =>
                            prevFiles.filter((_, i) => i !== index)
                          );
                        }}
                      />
                    ))}
                  </Box>

                  {errorMessage && (
                    <Typography
                      variant="body2"
                      sx={{ mt: 2, color: "red", fontWeight: "bold" }}
                    >
                      {errorMessage}
                    </Typography>
                  )}
                </StyledPaper>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ width: "32%" }}
                    onClick={() => {}}
                  >
                    UPDATE
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    sx={{ width: "32%" }}
                  >
                    DELETE
                  </Button>
                  <Button
                    variant="contained"
                    color="inherit"
                    sx={{ width: "32%" }}
                    onClick={onBack}
                  >
                    CANCEL
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ListingCustomCard;
